export const labTestAdviceCodeDetail = [
  {
    value: 'acNotTested',
    use: 'Kit not tested',
    description: 'Sample not yet submitted/tested.',
  },
  {
    value: 'acNSS',
    use: 'NSS',
    description:
      'No sperm cells seen in sample. This is the expected result after a vasectomy, as it meets the American Urological Association recommendation for post-vasectomy clearance at the time of testing.',
  },
  {
    value: 'acRetest4Week',
    use: 'RARE and 8+ weeks since DoV',
    description:
      'RARE sperm seen in sample. Recommend to retest after at least another 4 weeks and 10 ejaculations. Clearance of sperm after vasectomy can take multiple months.',
  },
  {
    value: 'acRetest6Week',
    use: 'MODERATE and 8+ weeks since DoV ',
    description:
      'MODERATE sperm seen in sample. Recommend to retest after at least another 6 weeks and 15 ejaculations. Clearance of sperm after vasectomy can take multiple months. ',
  },
  {
    value: 'acRetest8Week',
    use: 'RARE, MODERATE, or HIGH and < 8 weeks since DoV ',
    description:
      'RARE/MODERATE/HIGH sperm seen in sample, less than 8 weeks since vasectomy. Recommend to retest after at least another 8 weeks and 20 ejaculations. Clearance of sperm after vasectomy can take multiple months. ',
  },
  {
    value: 'acConsultProvider',
    use: 'HIGH and 8+ weeks since DOV',
    description: 'MODERATE/HIGH sperm seen in sample. Please contact your physician to discuss this result.',
  },
  {
    value: 'acConsultProviderSpecial',
    use: 'Manually select this option for other abnormal results, where patient should contact provider. Please enter specific instructions in provider notes field.',
    description: 'Please contact your physician to discuss this result.',
  },
  {
    value: 'acError',
    use: 'Testing error',
    description: 'An error occurred with the sample. Contact support for assistance.',
  },
]

